import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef, useMemo } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { BaseModal } from '@alfalab/core-components-base-modal/esm';
import { SIZE_TO_CLASSNAME_MAP } from './consts.js';
import { ResponsiveContext } from './ResponsiveContext.js';

var desktopStyles = {"wrapper":"modal__wrapper_6pd0s","component":"modal__component_6pd0s","fullscreen":"modal__fullscreen_6pd0s","size-500":"modal__size-500_6pd0s","size-600":"modal__size-600_6pd0s","size-800":"modal__size-800_6pd0s","size-1140":"modal__size-1140_6pd0s"};
require('./desktop/desktop.css')

var mobileStyles = {"component":"modal__component_1p1vi","content":"modal__content_1p1vi"};
require('./mobile/mobile.css')

var transitions = {"appear":"modal__appear_1rkx6","enter":"modal__enter_1rkx6","appearActive":"modal__appearActive_1rkx6","enterActive":"modal__enterActive_1rkx6","exit":"modal__exit_1rkx6","exitActive":"modal__exitActive_1rkx6","exitDone":"modal__exitDone_1rkx6"};
require('./transitions.css')

var Modal = forwardRef(function (_a, ref) {
    var _b;
    var _c;
    var _d = _a.size, size = _d === void 0 ? 500 : _d, fixedPosition = _a.fixedPosition, fullscreen = _a.fullscreen, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, _e = _a.transitionProps, transitionProps = _e === void 0 ? {} : _e, view = _a.view, dataTestId = _a.dataTestId, restProps = __rest(_a, ["size", "fixedPosition", "fullscreen", "children", "className", "wrapperClassName", "transitionProps", "view", "dataTestId"]);
    // TODO: удалить, после удаления пропсы fullscreen
    var componentSize = fullscreen ? 'fullscreen' : size;
    var modalRef = useRef(null);
    var handleEntered = function (node, isAppearing) {
        if (fixedPosition && modalRef.current) {
            var content = modalRef.current.querySelector(".".concat(desktopStyles.component));
            if (content) {
                var marginTop = window.getComputedStyle(content).marginTop;
                content.style.marginTop = marginTop;
            }
        }
        if (transitionProps.onEntered) {
            transitionProps.onEntered(node, isAppearing);
        }
    };
    var baseModalProps = view === 'desktop'
        ? {
            ref: mergeRefs([ref, modalRef]),
            wrapperClassName: cn(desktopStyles.wrapper, wrapperClassName, (_b = {},
                _b[desktopStyles.fullscreen] = componentSize === 'fullscreen',
                _b)),
            className: cn(desktopStyles.component, className, desktopStyles[SIZE_TO_CLASSNAME_MAP[componentSize]]),
            backdropProps: __assign({ invisible: componentSize === 'fullscreen' }, restProps.backdropProps),
            transitionProps: __assign(__assign({ classNames: transitions }, transitionProps), { onEntered: handleEntered }),
        }
        : {
            wrapperClassName: wrapperClassName,
            ref: ref,
            transitionProps: __assign({ classNames: transitions }, transitionProps),
            className: cn(className, mobileStyles.component),
            contentProps: __assign(__assign({}, restProps.contentProps), { className: cn(mobileStyles.content, (_c = restProps.contentProps) === null || _c === void 0 ? void 0 : _c.className) }),
        };
    var contextValue = useMemo(function () { return ({ size: componentSize, view: view, dataTestId: dataTestId }); }, [componentSize, view, dataTestId]);
    return (React.createElement(ResponsiveContext.Provider, { value: contextValue },
        React.createElement(BaseModal, __assign({}, restProps, baseModalProps, { dataTestId: dataTestId }), children)));
});
Modal.displayName = 'Modal';

export { Modal };
